import type { RouterConfig } from '@nuxt/schema';

export default <RouterConfig>{
  routes: _routes => {
    return [
      ..._routes,
      {
        name: 'subject',
        path: '/subject/:type/:page',
        component: () => import('~/pages/subject/index.vue'),
        meta: {
          layout: 'sidebar',
        },
      },
      {
        name: 'questions-id',
        path: '/questions-:id/:content?',
        component: () => import('~/pages/questions/index.vue'),
        meta: {
          layout: 'sidebar',
        },
      },
      {
        name: 'questions',
        path: '/questions/:id/:content?',
        component: () => import('~/pages/questions/index.vue'),
        meta: {
          layout: 'sidebar',
        },
      },
      {
        name: 'subjects',
        path: '/subjects',
        component: () => import('~/pages/subjects/index.vue'),
        meta: {
          layout: 'blog',
        },
      },
      {
        name: 'calculator',
        path: '/calculator',
        component: () => import('~/pages/calculator/index.vue'),
        meta: {
          layout: 'sidebar',
        },
      },
      {
        name: 'sitemap',
        path: '/sitemap-:page',
        component: () => import('~/pages/sitemap/index.vue'),
        meta: {
          layout: 'empty',
        },
      },
      {
        name: '404',
        path: '/404',
        component: () => import('~/error.vue'),
        meta: {
          layout: 'empty',
        },
      },
      {
        path: '/(tbl|tbs)',
        component: () => import('~/pages/textbook-list/index.vue'),
        children: [
          {
            name: 'textbook-list-without-subject',
            path: '/tbl',
            beforeEnter(to, from, next) {
              next({
                name: 'textbook-list',
                params: {
                  subject: 'all',
                  page: 1,
                },
              });
            },
          },
          {
            name: 'textbook-list-without-page',
            path: '/tbl/:subject',
            beforeEnter(to, from, next) {
              next({
                name: 'textbook-list',
                params: {
                  subject: to.params.subject,
                  page: 1,
                },
              });
            },
          },
          {
            name: 'textbook-list',
            path: '/tbl/:subject/:page',
            component: () => import('~/pages/textbook-list/explorer/index.vue'),
            meta: {
              layout: 'sidebar',
            },
          },
          {
            name: 'textbook-search',
            path: '/tbs',
            component: () => import('~/pages/textbook-list/search/index.vue'),
            meta: {
              layout: 'sidebar',
            },
          },
        ],
      },
      {
        path: '/tbd/:bookId/:directoryId?',
        component: () => import('~/pages/textbook-answer/index.vue'),
        meta: {
          layout: 'textbook-answer',
        },
      },
    ];
  },
};
